<template>
  <div class="banner-wrapper">
    <!-- 상단 플로팅 이미지들 -->
    <div class="floating-tags">
      <!-- VI 이미지 배너 -->
      <div class="vi-tag" @click="openVideoModal">
        <img src="@/assets/vi.gif" alt="홍보영상" class="vi-image" />
        <div class="vi-shine"></div>
      </div>

      <!-- Bottom 이미지 -->
      <div class="bottom-tag" @click="$emit('open-form')">
        <img src="@/assets/bottom.png" alt="상담신청" class="bottom-image" />
      </div>
    </div>

    <!-- 홍보영상 모달 -->
    <Transition name="video-modal">
      <div v-if="isVideoModalOpen" class="video-modal-overlay" @click.self="closeVideoModal">
        <div class="video-modal-content">
          <!-- 헤더 이미지 -->
          <div class="video-modal-header">
            <img src="@/assets/mobile/home2.jpg" alt="헤더" class="header-image" />
            <button class="modal-close-btn" @click="closeVideoModal">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
          </div>
          <!-- 영상 -->
          <div class="video-modal-body">
            <div class="video-box">
              <div class="video-container">
                <iframe
                  :src="modalVideoUrl"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>

    <div class="banner-container" @click="$emit('open-form')">
      <img src="@/assets/bottombanner.gif" alt="배너" class="banner-gif" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileBottomBanner',
  data() {
    return {
      isVideoModalOpen: false,
      modalVideoUrl: ''
    }
  },
  methods: {
    openVideoModal() {
      this.modalVideoUrl = 'https://www.youtube.com/embed/j4FL7_0jGQ8?autoplay=1&rel=0'
      this.isVideoModalOpen = true
      document.body.style.overflow = 'hidden'
    },
    closeVideoModal() {
      this.isVideoModalOpen = false
      this.modalVideoUrl = ''
      document.body.style.overflow = ''
    }
  }
}
</script>

<style scoped>
.banner-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

/* 상단 플로팅 이미지 컨테이너 */
.floating-tags {
  position: absolute;
  top: -105px;
  left: 12px;
  display: flex;
  align-items: flex-end;
  gap: -15px;
}

/* VI 이미지 배너 */
.vi-tag {
  cursor: pointer;
  animation: gentleBounce 2s ease-in-out infinite;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 2;
}

/* Bottom 이미지 배너 */
.bottom-tag {
  cursor: pointer;
  animation: bottomBounce 1.5s ease-in-out infinite;
  position: relative;
  z-index: 1;
  margin-left: -30px;
  align-self: flex-end;
  margin-bottom: -20px;
}

.bottom-image {
  display: block;
  height: 90px;
  width: auto;
}

@keyframes bottomBounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

@keyframes gentleBounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-3px); }
}

.vi-image {
  display: block;
  height: 75px;
  width: auto;
}

/* 유리 빛나는 효과 */
.vi-shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    120deg,
    transparent 30%,
    rgba(255, 255, 255, 0.4) 50%,
    transparent 70%
  );
  animation: shine 3s ease-in-out infinite;
}

@keyframes shine {
  0% { left: -100%; }
  50%, 100% { left: 100%; }
}

.vi-tag:active {
  transform: scale(0.97);
}


/* ===== 홍보영상 모달 ===== */
.video-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
}

.video-modal-content {
  width: 100%;
  max-width: 500px;
  background: #000;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.video-modal-header {
  position: relative;
  width: 100%;
}

.header-image {
  width: 100%;
  height: auto;
  display: block;
}

.modal-close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  backdrop-filter: blur(4px);
}

.modal-close-btn svg {
  width: 18px;
  height: 18px;
}

.video-modal-body {
  width: 100%;
  padding: 16px;
  background: #0C1B45;
}

.video-box {
  background: #0C1B45;
  border-radius: 12px;
  overflow: hidden;
}

.video-container {
  width: 100%;
  padding-bottom: 56.25%;
  position: relative;
}

.video-container iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

/* 모달 트랜지션 */
.video-modal-enter-active {
  animation: modalSlideDown 0.4s ease;
}

.video-modal-leave-active {
  animation: modalSlideUp 0.3s ease;
}

@keyframes modalSlideDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes modalSlideUp {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-30px);
  }
}

.banner-container {
  width: 100%;
  cursor: pointer;
}

.banner-gif {
  display: block;
  width: 100%;
  height: auto;
}
</style>
